export interface CacTab {
  id: string
  labelKey: string
  route: string
  order: number
}

export const cacTabs: CacTab[] = [
  { id: 'orders', labelKey: 'nav.orders', route: '/orders', order: 10 },
  { id: 'wishlist', labelKey: 'nav.wishlist', route: '/wishlist', order: 20 },
  { id: 'profile', labelKey: 'nav.profile', route: '/profile', order: 30 },
]

export const orderedCacTabs = (): CacTab[] => [...cacTabs].sort((a, b) => a.order - b.order)
